<template>
    <section class="NewsListing">
        <div class="container pb-large lap-and-up-pb-xlarge">
            <FilterNav
                class="FilterNav--listing"
                v-if="categories"
                heading="Filter:"
                :categories="categories"
                :activeFilter.sync="activeFilter"
            >
                <div
                    class="NewsListing__reset hide--palm"
                    @click="resetFilters"
                >
                    <span
                        class="heavier text--blue mr-small"
                    >
                        Clear filters
                    </span>
                    <BaseIcon
                        icon="reset"
                        class="text--redpink"
                    />
                </div>
            </FilterNav>

            <NewsCardFeatured
                v-if="featured"
                :item="featured"
            />

            <div class="grid grid--none">
                <div
                    v-for="item in entriesOnPage"
                    :key="item.id"
                    class="grid__item one-half desk-one-third"
                >
                    <NewsCard
                        :item="item"
                        :tag="item.productLocations"
                    />
                </div>
            </div>

            <BaseButton
                v-if="paginate && filteredItems.length > load"
                @click="load += paginate"
            >
                Load More
            </BaseButton>
        </div>
    </section>

</template>

<script>
import FilterNav from '@components/FilterNav.vue'

export default {
    name: 'NewsListing',
    components: {
        FilterNav,
    },
    data() {
        return {
            filteredItems: this.items,
            currentFeatured: null,
            load: 7,
            paginate: 6,
            activeFilter: '',
        }
    },
    props: {
        items: {
            type: Array
        },
        featuredDefault: {
            type: String,
            default: null
        }
    },
    computed: {
        categories: function() {
            return this.items.reduce((total, curr) => {
                curr.categories.filter( (cat) => total.indexOf(cat) === -1)
                    .map( (cat) => total.push(cat));
                total = total.filter((item) => item !== 'Latest');
                total.unshift('Latest');
                return total;
            }, [])
        },
        entriesOnPage: function ()  {
            return this.filteredItems.slice(1, this.load);
        },
        featured: function ()  {
            return this.filteredItems[0]
        }
    },
    methods: {
        resetFilters() {
            this.activeFilter = 'Latest'
        }
    },
    watch: {
        activeFilter() {
            if (this.activeFilter === 'Latest') {
                const filteredItems = this.items
                if (this.featuredDefault) {
                    const currentFeatured = filteredItems.filter((item) => item.title === this.featuredDefault)
                    filteredItems.unshift(currentFeatured)
                }
                this.filteredItems = filteredItems
            } else {
                const filteredItems = this.items.filter((item) => item.categories.indexOf(this.activeFilter) >= 0)
                const currentFeatured = filteredItems.filter((item) => item.featuredInCat === this.activeFilter)
                if (currentFeatured.length) {
                    filteredItems.unshift(currentFeatured[0])
                }
                this.filteredItems = filteredItems
            }
        }
    },
    created() {
        this.activeFilter = 'Latest'
    }
}
</script>
<style lang="scss" scoped>

    .FilterNav {
        border-top: 1px solid $border-color;
        padding-top: getSpacing(medium);
    }

    .NewsListing__reset {
        cursor: pointer;
        display: flex;
        align-items: center;
        font-size: 14px;
    }

    .BaseButton {
        display: block!important;
        margin: auto;
        width: 150px;
        padding-left: 1.5rem!important;
        padding-right: 1.5rem!important;
        cursor: pointer;
        margin-top: getSpacing('large');
    }
</style>

